// Id em `plantios` quando o detalhe aberto é de um plantio específico; null no modo legado.
export function plantioScopeId(talhao) {
  return talhao?._operationalHistory && talhao._plantingId != null ? talhao._plantingId : null;
}

const day = value => (value ? String(value).slice(0, 10) : '');

// Foto com plantio_id pertence só a ele; foto antiga (sem plantio_id) pertence ao plantio cujo período a contém.
export function fotoPertenceAoPlantio(foto, talhao) {
  const plantioId = plantioScopeId(talhao);
  if (plantioId == null) return true;
  if (foto.plantio_id != null) return String(foto.plantio_id) === String(plantioId);
  const dataFoto = day(foto.data_foto);
  const inicio = day(talhao.data_plantio);
  const fim = day(talhao.data_colheita);
  if (!dataFoto || !inicio) return false;
  return dataFoto >= inicio && (!fim || dataFoto <= fim);
}
